import type { RouteRecordRaw } from 'vue-router';

import { RouteName } from '@/core/router/RouteName';

const routes: readonly RouteRecordRaw[] = [
  {
    name: RouteName.REGLEMENTAIRE_TRAITEMENT_RECLAMATIONS,
    path: '/reglementaire/traitement-reclamations',
    component: () => import('@/domains/reglementaire/views/TraitementReclamationsPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
];

export default routes;
